import { render } from "./TextCamp.vue?vue&type=template&id=18b41b61&scoped=true"
import script from "./TextCamp.vue?vue&type=script&lang=js"
export * from "./TextCamp.vue?vue&type=script&lang=js"

import "./TextCamp.vue?vue&type=style&index=0&id=18b41b61&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b41b61"]])

export default __exports__